// @flow @jsx h
/* eslint-disable jsx-a11y/label-has-for,compat/compat */
/* eslint-disable promise/always-return */

import { Component, h } from 'preact'

/* styles */
import styles from './index.css'
import appStyles from '../App.css'

/* types */
import type { Tag } from '../types'

const baseUrl = 'https://www.nrk.no/orderud/orderud-_-sporsmal-og-svar-1.14242569'

function createUrl (tag: ?Tag) {
  const localUrl = tag ? `#/filter/${tag.slug}` : '#/'
  return baseUrl + localUrl
}

type Props = {
  tags: Tag[]
}

export class TagLinks extends Component<Props, State> {
  render () {
    const { tags } = this.props

    const spor = Object.values(tags)
      .filter(tag => tag.category === 'spor')
      .sort((a, b) => b.count - a.count)
      .filter((tag, idx) => idx < 10)

    return (
      <div class={styles.tagWrapper + ' ' + appStyles.app__element}>
        <h2>Spørsmål og svar</h2>
        {
          spor.map((tag, i) => {
            return <a
              key={'spor' + i}
              href={createUrl(tag)}
              className={`${styles.tag} nrk-button`}>
              {tag.text}
            </a>
          })
        }
        <div>
          <a
            href={createUrl(null)}
            class={`${styles.viewAll} nrk-button`}>
            Se alle spørsmål og svar
          </a>
        </div>
      </div>
    )
  }
}
